'use client';

import { c as _c } from "react/compiler-runtime";
import './birthday-appeal.scss';
import { useTranslation } from 'react-i18next';
import { TooltipInfo } from '@sola/ark-core/molecules/tooltip-info/tooltip-info.tsx';
import { cn } from '@sola/ark-core/utils/helpers.ts';
import { ArkIcon } from '@sola/ark-icons/lib/ark-icon.tsx';
import { Image } from '../../atoms/image/image.tsx';
export interface BirthdayAppealAcceptedProps {
  childName: string;
  isBusy?: boolean;
  addedTitle?: string;
  imageUrl?: string;
  imageAlt?: string;
  price?: string;
  className?: string;
  background?: string;
  flush?: boolean;
  onEdit?: () => void;
  onRemove: () => void;
}
export const BirthdayAppealAccepted: React.FC<BirthdayAppealAcceptedProps> = t0 => {
  const $ = _c(41);
  const {
    childName,
    isBusy: t1,
    addedTitle,
    imageUrl,
    imageAlt,
    price,
    className,
    background,
    flush: t2,
    onEdit,
    onRemove
  } = t0;
  const isBusy = t1 === undefined ? false : t1;
  const flush = t2 === undefined ? false : t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = ["checkout"];
    $[0] = t3;
  } else {
    t3 = $[0];
  }
  const {
    t
  } = useTranslation(t3);
  let t4;
  if ($[1] !== addedTitle || $[2] !== childName || $[3] !== t) {
    t4 = addedTitle ?? t("checkout:birthdayAppeal.addedTitle", {
      name: childName,
      defaultValue: "Birthday Gift for {{name}}"
    });
    $[1] = addedTitle;
    $[2] = childName;
    $[3] = t;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const addedTitleText = t4;
  const t5 = flush ? "BirthdayAppeal--flush" : "p-comfy-sm";
  let t6;
  if ($[5] !== className || $[6] !== t5) {
    t6 = cn("BirthdayAppeal BirthdayAppeal--added", t5, className);
    $[5] = className;
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== background) {
    t7 = background ? {
      background
    } : undefined;
    $[8] = background;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== imageAlt || $[11] !== imageUrl) {
    t8 = <div className="BirthdayAppeal__thumb">{imageUrl ? <Image image={{
        url: imageUrl,
        alt: imageAlt ?? ""
      }} className="BirthdayAppeal__image overflow-hidden w-full h-full object-cover" /> : <div className="BirthdayAppeal__icon"><ArkIcon iconName="birthday-cake" /></div>}</div>;
    $[10] = imageAlt;
    $[11] = imageUrl;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== addedTitleText) {
    t9 = <div className="BirthdayAppeal__title label-lg label-moderate">{addedTitleText}</div>;
    $[13] = addedTitleText;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== isBusy || $[16] !== onEdit || $[17] !== t) {
    t10 = onEdit && <><button type="button" className="BirthdayAppeal__link BirthdayAppeal__link--edit" onClick={onEdit} disabled={isBusy}>{t("checkout:birthdayAppeal.edit", {
          defaultValue: "Edit"
        })}</button><span className="BirthdayAppeal__divider" aria-hidden="true" /></>;
    $[15] = isBusy;
    $[16] = onEdit;
    $[17] = t;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== t) {
    t11 = t("checkout:birthdayAppeal.remove", {
      defaultValue: "Remove"
    });
    $[19] = t;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== isBusy || $[22] !== onRemove || $[23] !== t11) {
    t12 = <button type="button" className="BirthdayAppeal__link BirthdayAppeal__link--remove" onClick={onRemove} disabled={isBusy}>{t11}</button>;
    $[21] = isBusy;
    $[22] = onRemove;
    $[23] = t11;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] !== t10 || $[26] !== t12) {
    t13 = <div className="BirthdayAppeal__links flex items-center gap-snug-xl label-md">{t10}{t12}</div>;
    $[25] = t10;
    $[26] = t12;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  let t14;
  if ($[28] !== t13 || $[29] !== t9) {
    t14 = <div className="BirthdayAppeal__content flex flex-col gap-snug-md">{t9}{t13}</div>;
    $[28] = t13;
    $[29] = t9;
    $[30] = t14;
  } else {
    t14 = $[30];
  }
  let t15;
  if ($[31] !== childName || $[32] !== price || $[33] !== t) {
    t15 = price && <div className="BirthdayAppeal__price flex items-center gap-snug-xl label-lg label-amplified"><TooltipInfo align="end" side="top" size="sm" triggerClassName="BirthdayAppeal__info" triggerLabel={t("checkout:birthdayAppeal.infoLabel", {
        defaultValue: "Birthday gift information"
      })}>{t("checkout:birthdayAppeal.info", {
          name: childName,
          defaultValue: "This birthday gift is added to your sponsorship for {{name}}."
        })}</TooltipInfo><span>{price}</span></div>;
    $[31] = childName;
    $[32] = price;
    $[33] = t;
    $[34] = t15;
  } else {
    t15 = $[34];
  }
  let t16;
  if ($[35] !== t14 || $[36] !== t15 || $[37] !== t6 || $[38] !== t7 || $[39] !== t8) {
    t16 = <div className={t6} style={t7}>{t8}{t14}{t15}</div>;
    $[35] = t14;
    $[36] = t15;
    $[37] = t6;
    $[38] = t7;
    $[39] = t8;
    $[40] = t16;
  } else {
    t16 = $[40];
  }
  return t16;
};